// extracted by mini-css-extract-plugin
export default {"paymentSection":"A8-z"};